import { ColumnScreenKey, IColumnOption } from "../types/columnSettings.type";

export const columnSettingsRegistry: Record<
  ColumnScreenKey,
  { label: string; columns: IColumnOption[] }
> = {
  orders: {
    label: "Заказы",
    columns: [
      { key: "date", label: "Дата", defaultVisible: true },
      { key: "receipt", label: "Чек", defaultVisible: true },
      { key: "clientName", label: "Имя клиента", defaultVisible: true },
      { key: "description", label: "Описание", defaultVisible: false },
      { key: "type", label: "Тип", defaultVisible: true },
      { key: "kind", label: "Тип сущ.", defaultVisible: true },
      { key: "name", label: "Имя", defaultVisible: true },
      { key: "unitOfMeasurement", label: "Ед. измерения", defaultVisible: true },
      { key: "currency", label: "Валюта", defaultVisible: true },
      { key: "exchangeRate", label: "Курс", defaultVisible: true },
      { key: "price", label: "Цена", defaultVisible: true },
      { key: "total", label: "Кол-во", defaultVisible: true },
      { key: "totalKg", label: "Кол-во (2)", defaultVisible: true },
      { key: "totalCost", label: "Сумма", defaultVisible: true },
      { key: "balanceBefore", label: "Баланс до", defaultVisible: true },
      { key: "balanceAfter", label: "Баланс после", defaultVisible: true },
      { key: "residueBefore", label: "Остаток до", defaultVisible: true },
      { key: "residueAfter", label: "Остаток после", defaultVisible: true },
      { key: "returned", label: "Возврат", defaultVisible: true },
      { key: "status", label: "Статус", defaultVisible: true },
      { key: "ownerName", label: "Создал", defaultVisible: true },
      { key: "actions", label: "Действия", defaultVisible: true },
    ],
  },
  transactions: {
    label: "Транзакции",
    columns: [
      { key: "transactionId", label: "ID", defaultVisible: true },
      { key: "date", label: "Дата", defaultVisible: true },
      { key: "status", label: "Статус", defaultVisible: true },
      { key: "cashboxName", label: "Касса", defaultVisible: true },
      { key: "cashierName", label: "Кассир", defaultVisible: true },
      { key: "description", label: "Описание", defaultVisible: true },
      { key: "currency", label: "Валюта", defaultVisible: true },
      { key: "balanceBefore", label: "Баланс до", defaultVisible: true },
      { key: "balanceAfter", label: "Баланс после", defaultVisible: true },
      { key: "amount", label: "Сумма", defaultVisible: true },
      { key: "profit", label: "Доход", defaultVisible: true },
      { key: "exchangeRate", label: "Курс", defaultVisible: true },
      { key: "type", label: "Тип", defaultVisible: true },
      { key: "creditType", label: "Тип прихода", defaultVisible: true },
      { key: "expenseType", label: "Тип расхода", defaultVisible: true },
      { key: "workerName", label: "Имя сотрудника", defaultVisible: true },
      { key: "clientName", label: "Имя клиента", defaultVisible: true },
      { key: "salesUserName", label: "Продажник", defaultVisible: true },
      { key: "machineName", label: "Имя станка", defaultVisible: true },
      { key: "partnerName", label: "Имя партнёра", defaultVisible: true },
      { key: "salaryDebtBefore", label: "Зарплата долг до", defaultVisible: true },
      { key: "salaryDebtAfter", label: "Зарплата долг после", defaultVisible: true },
      { key: "actions", label: "Действия", defaultVisible: true },
    ],
  },
  partnerLogs: {
    label: "Логи партнёров",
    columns: [
      { key: "date", label: "Дата", defaultVisible: true },
      { key: "partnerId", label: "Партнер", defaultVisible: false },
      { key: "type", label: "Тип", defaultVisible: true },
      { key: "amount", label: "Сумма", defaultVisible: true },
      { key: "balanceBefore", label: "Баланс до", defaultVisible: true },
      { key: "balanceAfter", label: "Баланс после", defaultVisible: true },
      { key: "description", label: "Описание", defaultVisible: true },
      { key: "ownerId", label: "Создал", defaultVisible: false },
    ],
  },
};

export const getDefaultColumnVisibility = (
  screenKey: ColumnScreenKey
): Record<string, boolean> =>
  columnSettingsRegistry[screenKey].columns.reduce<Record<string, boolean>>(
    (acc, column) => {
      acc[column.key] = column.defaultVisible;
      return acc;
    },
    {}
  );

export const filterColumnVisibility = (
  screenKey: ColumnScreenKey,
  columns?: Record<string, unknown>
): Record<string, boolean> => {
  const defaults = getDefaultColumnVisibility(screenKey);
  const allowedKeys = new Set(Object.keys(defaults));

  if (!columns || typeof columns !== "object") {
    return defaults;
  }

  return Object.entries(columns).reduce<Record<string, boolean>>((acc, [key, value]) => {
    if (allowedKeys.has(key) && typeof value === "boolean") {
      acc[key] = value;
    }

    return acc;
  }, { ...defaults });
};
